import { render, staticRenderFns } from "./HealthtoolNavbar.vue?vue&type=template&id=b841a538&"
import script from "./HealthtoolNavbar.vue?vue&type=script&lang=js&"
export * from "./HealthtoolNavbar.vue?vue&type=script&lang=js&"
import style0 from "./HealthtoolNavbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports